module.exports = __webpack_public_path__ + "media/images/illustrations/enrichment-programme-d873eb2249090106caf5ac1e234adc5f.svg";